import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ImgPreviewComponent } from './img-preview.component';

@NgModule({
  declarations: [ImgPreviewComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [ImgPreviewComponent]
})
export class ImgPreviewModule { }
